import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { partnerAcceptInvite } from "../../services/partnerCalls";
import { Shell, Card, Btn, Input, Note } from "./portalPublic";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const t = params.get("t") || "";
  const [form, setForm] = useState({ firstName: "", lastName: "", password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!t) return setError("This invite link is missing its token.");
    // the same rule the partner API applies
    if (form.password.length < 10) return setError("Choose a password of at least 10 characters.");
    if (!/[A-Za-z]/.test(form.password) || !/[0-9]/.test(form.password)) return setError("Use both letters and numbers in your password.");
    if (form.password !== form.confirm) return setError("Passwords don't match.");
    setBusy(true);
    try {
      const out = await partnerAcceptInvite({ token: t, password: form.password, firstName: form.firstName, lastName: form.lastName });
      // next: reveal the partner's live API key, once
      if (out?.reveal_url) return navigate(out.reveal_url, { replace: true });
      setDone(true);
    } catch (err) {
      setError(err?.response?.data?.message || "This invite is invalid or has expired.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Shell>
      <Card title="Set up your portal account">
        {error && <Note tone="error">{error}</Note>}
        {done ? (
          <>
            <Note>Your account is ready.</Note>
            <Link to="/partner-login"><Btn>Go to sign in →</Btn></Link>
          </>
        ) : (
          <form onSubmit={submit}>
            <Input placeholder="First name" value={form.firstName} onChange={set("firstName")} />
            <Input placeholder="Last name" value={form.lastName} onChange={set("lastName")} />
            <Input type="password" placeholder="Password (min 10 chars, letters and numbers)" value={form.password} onChange={set("password")} />
            <Input type="password" placeholder="Confirm password" value={form.confirm} onChange={set("confirm")} />
            <Btn type="submit" disabled={busy}>{busy ? "Setting up…" : "Create account"}</Btn>
          </form>
        )}
      </Card>
    </Shell>
  );
}
